'use strict';

var app = angular.module('saturn.form.switch', []);

var SwitchDirective = require('./SwitchDirective');

app.directive('sbSwitch', [
  '$$rAF',
  '$parse',
  SwitchDirective
]);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/form/src/switch/index.js